<template>
  <div>
    <div class="ele" v-loading="loadingImg">
      <img
        :src="item"
        v-for="(item, index) in imgList"
        :class="['img',dyClassName]"
        @click="previewSrc(index)"
        :key="index"
      >
    </div>
    <el-image-viewer
      v-if="showViewer"
      :on-close="closeViewer"
      :url-list="previewSrcList"
    />
  </div>
</template>
<script>
import ElImageViewer from './ImageView'

export default {
  name: 'bluePrint',
  components: { ElImageViewer },
  props:{
      bridgeId:{
          type: String,
          required: true,
      }
  },
  data() {
    return {
      imgList: [],
      loadingImg: false,
      showViewer: false,
      previewSrcList: [],
      timer: null
    }
  },
  mounted() {
    this.getImgList()
    this.timer = setInterval(() => {
      this.checkAuth()
    }, this.REFRESH_SECOND)
  },
  computed: {
    dyClassName() {
      let imgClass = ''
      let len = this.imgList.length || 0
      switch (len) {
        case 1:
          imgClass = 'img1'
          break
        case 2:
          imgClass = 'img2'
          break
        default:
          imgClass = 'img3'
          break
      }
      return imgClass
    }
  },
  watch: {
    showViewer(val) {
      if (val) {
        this.$nextTick(() => {
        let viewEr = document.getElementsByClassName('el-image-viewer__img')[0]
        console.log('viewEr', viewEr)
        })
      }
    }
  },
  beforeDestroy() {
    clearInterval(this.timer)
  },
  methods: {
    checkAuth() {
      this.$http.get('/auth/LoginInfo').then(res => {})
    },
    closeViewer() {
      this.previewSrcList = []
      this.showViewer = false
    },
    previewSrc(index) {
      let imgList = [...this.imgList]
      this.previewSrcList = [
        ...imgList.splice(index),
        ...imgList.splice(0, index)
      ]
      this.showViewer = true
    },
    getImgList() {
      this.loadingImg = true
      this.$http
        .get(
          `/blueprint/BlueprintList?bridgeId=`+this.bridgeId
        )
        .then(res => {
          this.loadingImg = false
          let imgL = []
          res.data.forEach(el => {
            imgL.push(`/blueprint/BlueprintFile?blueprint=${el}`)
          })
          this.imgList = imgL
        })
        .catch(() => {
          this.loadingImg = false
        })
    }
  }
}
</script>
<style lang="scss" scoped>
.ele {
  margin-top: 1%;
  height: 95% !important;
  flex-wrap: wrap;
  display: flex;
  justify-content: space-between;
}
.img {
  display: block;
  height: 100%;
  cursor: pointer;
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  margin-bottom: 20px;
}
.img1 {
 max-width: 100%;
 max-height: 100%;
 margin: 0 auto;
}
.img2 {
  width: 48%;
}
.img3 {
  width: 48%;
  height: 65%;
}
</style>
